import { LOCATION_CHANGE } from 'connected-react-router';

import type { AnyFSA } from '@makemydeal/dr-browser-utils';
import type { ReduxNext, ReduxStore } from '@makemydeal/dr-shared-store';
import { getActiveDeal, getDealXgId } from '@makemydeal/dr-sales-checkin-store';
import { getUrlSearchParams, setDealXgVersionPin, syncDealXgVersionInUrl } from '@makemydeal/dr-sales-checkin-ui-utils';

/**
 * Mirrors the active deal's version into the two places a page *load* reads it: the dealXgVersion
 * URL param and the session-pinned version (fetchBootstrapDataWorker consumes the session copy,
 * scoped to the deal it belongs to via setDealXgVersionPin). Redux stays the source of truth; these
 * are write-only mirrors, so a refresh comes back on the version the user was viewing.
 *
 * Keyed on the version value changing rather than on specific action types, so every path —
 * bootstrap, vehicle change, trade-in add/remove, deal refresh — is covered without enumerating
 * them, and a new mutation path is covered for free.
 */
// TODO: visit later for clean approach
export const dealVersionSyncMiddleware = (store: ReduxStore<any>) => {
    let lastSyncedVersion: string | undefined;

    const hasStaleUrlVersion = (action: AnyFSA, version: string): boolean => {
        if (action.type !== LOCATION_CHANGE) return false;
        const urlVersion = getUrlSearchParams('dealXgVersion') as string;
        return !!urlVersion && urlVersion !== version;
    };

    return (next: ReduxNext) => (action: AnyFSA) => {
        next(action);

        const version = getActiveDeal(store.getState()).dealStructure?.version;
        if (!version || (version === lastSyncedVersion && !hasStaleUrlVersion(action, version))) return;

        lastSyncedVersion = version;
        setDealXgVersionPin(getDealXgId(store.getState()), version);
        syncDealXgVersionInUrl(version);
    };
};
